import { render } from "./allusers.vue?vue&type=template&id=315288fe"
import script from "./allusers.vue?vue&type=script&lang=js"
export * from "./allusers.vue?vue&type=script&lang=js"

import "./allusers.vue?vue&type=style&index=0&id=315288fe&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__